const routes = [
  {
    path: "/manutencao-curso-superior",
    name: "manutencao-curso-superior",
    meta: {
      allowedPermissions: ["curso_servidor_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDeCursoSuperior/ManutencaoDeCursoSuperiorHome.vue"
      ),
  },
  {
    path: "/manutencao-curso-superior/novo",
    name: "manutencao-curso-superior-novo",
    meta: {
      allowedPermissions: ["curso_servidor_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDeCursoSuperior/ManutencaoDeCursoSuperiorCad.vue"
      ),
  },
  {
    path: "/manutencao-curso-superior/editar/:id",
    name: "manutencao-curso-superior-editar",
    meta: {
      allowedPermissions: ["curso_servidor_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDeCursoSuperior/ManutencaoDeCursoSuperiorEdit.vue"
      ),
  },
];

export default routes;
